
import React from 'react';

// Componente SolutionSection
const solutions = [
  {
    title: "Datos Oncológicos Estandarizados",
    icon: "fa-database",
    text: "Cada prescripción, dispensación y administración queda registrada usando mCODE®, estructurando los datos oncológicos de forma estándar para facilitar la interoperabilidad.",
    benefits: ["Formato de datos interoperable", "Facilita auditorías e inspecciones", "Redondeo clínico ±10% (HOPA/ASCO)", "Optimización del uso de viales"]
  },
  {
    title: "Trazabilidad Completa en FHIR",
    icon: "fa-project-diagram",
    text: "Cada acción queda registrada en formato HL7 FHIR estándar: quién prescribió, quién preparó en farmacia y quién administró al paciente con trazabilidad temporal exacta.",
    benefits: ["Registro automático de cada acción", "Cumplimiento regulatorio estricto", "Historial completo para auditorías", "Datos en formato estándar abierto"]
  },
  {
    title: "Implementación Ágil y Guiada",
    icon: "fa-handshake",
    text: "No es una prueba, es un despliegue funcional inmediato. Solo requiere la creación de su clínica y usuarios para comenzar a operar bajo estándares internacionales.",
    benefits: ["Sistema funcionando en minutos", "Configuración personalizada incluida", "Capacitación para todo el equipo", "Soporte prioritario experto", "Acompañamiento en el flujo real"]
  }
];

const SolutionSection: React.FC = () => {
  return (
    <section id="solucion" className="py-24 bg-slate-50 scroll-mt-20">
      <div className="container mx-auto px-4 md:px-8">
        <div className="text-center mb-20">
          <span className="text-[#0284c7] font-bold text-sm uppercase tracking-widest">NUESTRO ENFOQUE</span>
          <h2 className="text-3xl md:text-5xl font-bold mt-4 italic text-dark tracking-tight">Construido con Estándares Profesionales</h2>
        </div>

        <div className="grid lg:grid-cols-3 gap-8">
          {solutions.map((item, idx) => (
            <div key={idx} className="bg-white p-10 rounded-3xl shadow-sm border border-slate-100 hover:shadow-xl transition-all group">
              <div className="w-16 h-16 bg-blue-50 text-[#1e3a8a] rounded-2xl flex items-center justify-center mb-8 group-hover:bg-medical group-hover:text-white transition-colors">
                <i className={`fas ${item.icon} text-2xl`}></i>
              </div>
              <h3 className="text-2xl font-bold mb-4 text-[#0f172a]">{item.title}</h3>
              <div className="text-slate-500 mb-8 leading-relaxed font-medium">
                {item.text}
              </div>
              <ul className="space-y-3">
                {item.benefits.map((benefit, bIdx) => (
                  <li key={bIdx} className="flex items-center text-sm font-bold text-slate-700">
                    <i className="fas fa-check-circle text-onco mr-3"></i>
                    {benefit}
                  </li>
                ))}
              </ul>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
};

export default SolutionSection;
